import convert from 'convert-units'

export const gramsToTonnes = (grams: number) =>
	convert(grams).from('g').to('mt')
export const kgToTonnes = (kgs: number) => convert(kgs).from('kg').to('mt')
export const gramsToKg = (grams: number) => convert(grams).from('g').to('kg')
